import React from "react";
import { BackendInterface } from "../..";

export const BackendContext = React.createContext<BackendInterface | null>(
  null
);

export const useBackend = () => {
  const backend = React.useContext(BackendContext);
  if (!backend) {
    throw new Error("useBackend must be used within a BackendProvider");
  }
  return backend;
};
